import { CustomRadio } from "components/CustomRadio/CustomRadio";
import { Container } from "./styles";
import { RESERVATION_STATES } from "../../RegularReservationActivity/RegularReservationView/utils/constants";

const ReservationStateField = ({
	finalized, reservationState
}) => {
	return (
		<Container>
			{RESERVATION_STATES.map(({
				label, value
			}, idx) => (
				<CustomRadio
					key={idx}
					label={label}
					checked={reservationState.isChecked(value)}
					onChange={() => reservationState.change(value)}
					disabled={finalized} />
			))}
		</Container>
	);
}

export default ReservationStateField;